import AppUtil from "@/util/AppUtil";
/**订单数据*/
export default class OrderVo {
    id:number=0;
    orderCode!: string;
    createDate!: string;
    /**服务产品数组 */
    serveJson: any[] = [];
    /**订单总价 */
    orderPrice: number=0;
    /**订单状态 */
    orderState:number=0;
    orderName:string="加载中...";
    orderPhone:string="";
    arrivalDate:string="";
    arrivalTime:string="";
    /**支付方式：1微信支付，2会员卡支付，3股本支付，4欠款，5线下支付，9零元订单，10套餐预约使用*/
    payMode:number=0;
    private payArr=["","微信支付","会员卡支付","股本支付","欠款","线下支付","未知支付方式","未知支付方式","未知支付方式","零元订单","套餐预约使用"];
    /**不同状态对应的操作 */
    private stateBtnArr=[
       [ {plain:true,text:"取消订单",type:"cancel"},
        {plain:false,text:"支付订单",type:"pay"}],
       
        [ {plain:true,text:"取消订单",type:"cancel"},
        {plain:false,text:"查看订单",type:"look"}],

        [ {plain:true,text:"查看订单",type:"look"},
        {plain:false,text:"核销码",type:"code"}],

        [ {plain:false,text:"查看订单",type:"look"}],

        [ {plain:false,text:"查看订单",type:"look"}],
    ];
    /**不包含查看订单按钮 */
    private minBtnArr=[
        [ {plain:true,text:"取消订单",type:"cancel"},
         {plain:false,text:"支付订单",type:"pay"}],
        
         [ {plain:true,text:"取消订单",type:"cancel"},],
 
         [{plain:false,text:"核销码",type:"code"}],
     ];
    /**订单状态（不传查全部）：0待支付，1已支付/待接单，2已接单/待到店，3已完成，4已取消 ，7已删除*/
    private stateArr=["待支付","待接单","待到店","已完成","已取消","","","已删除"];
    constructor(data: any={}) {
        for (var i in data) { //for in 会遍历对象的属性，包括实例中和原型中的属性。（需要可访问，可枚举属性）
            (this as any)[i] = data[i];
        }
        this.serveJson = data.serveJson || [];
    }
    /**服务产品数组 */
    public get pdcArr() {
        if(!this.serveJson){
            return []
        }
        this.serveJson.map((pdc: any) => {
            pdc.thumb = AppUtil.get_thumb(pdc.serveLogo, 250, 325);
        });
        return this.serveJson;
        
    }
    /**订单状态 */
    public get stateTxt():string{
        return this.stateArr[this.orderState];
    }
    public get payTxt():string{
        let payMode= this.payMode||0;
        return this.payArr[payMode];
    }
    public get btnArr(){
        return this.stateBtnArr[this.orderState];
    }
    /**详情页按钮 */
    public get detailBtnArr(){
        if(this.orderState>2){
            return []
        }
        return this.minBtnArr[this.orderState];
    }
}
